import React,{useContext} from 'react';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
//import Highlight from 'react-highlight'
import { ThemeContext } from '../App';

export default function HomePage() {
  const currentTheme = useContext(ThemeContext);
  const navigate = useNavigate();
  return (
    <Container maxWidth="md">
      <link rel="stylesheet" href="/assets/vs2015.css"/>
      <Box sx={{ my: 10, textAlign:'center', position:'relative' }}>
        <Typography variant="h3" component="h1" sx={{position:'relative',fontWeight:700, zIndex:100}} color="text.header">
          Excel-Like Formulas for .NET
        </Typography>
        <Box className="blob">&nbsp;</Box>
        <Box className="blob2">&nbsp;</Box>
        <Paper sx={{position:'relative', zIndex:100,maxWidth:'sm', mx:'auto', my:5, textAlign:'left', padding:{sm:2, xs:1}}}>
          {
          //braces: &#123; &#125;
          //&nbsp;&nbsp;
          }
          <code>
          <Typography sx={{ fontFamily:'source-code-pro, Menlo, Monaco, Consolas, \'Courier New\', monospace', typography: { sm: {fontSize:'1rem'}, xs: {fontSize:'0.9rem'} }}} >
            <span className="hljs-keyword">var</span> formulator = <span className="hljs-keyword">new</span> Formulator();
            formulator.Variable(<span className="hljs-string">"foo"</span>,<span className="hljs-string">"bar"</span>);<br/>
            <span className="hljs-keyword">var</span> result = formulator.Evaluate(<span className="hljs-string">@"IF(AND(foo = ""bar"", Date.Now()&gt; ""1 JAN 2020""),String.ToUpper(foo),""foobar"")"</span>);<br/>
            <span className="hljs-comment">//result: BAR</span><br/>
          </Typography>
        </code>
        </Paper>
        <Button variant="contained" sx={{textTransform:'none',zIndex:101}} onClick={()=>{navigate('/demo')}}>Try the Demo</Button>
      </Box>
    </Container>
  );
}